export const MIN_VISIBLE_MS = 500;
export const FULL_SCREEN_DELAY_MS = 1000;
export const MESSAGE_ROTATE_MS = 2500;
export const NPROGRESS_TRICKLE_MS = 200;

export const LOADING_TYPES = {
  DEFAULT: "default",
  NAVIGATION: "navigation",
  FIRESTORE: "firestore",
  REPORT: "report",
  UPLOAD: "upload",
  IMPORT: "import",
  EXPORT: "export",
  BATCH: "batch",
  AUTH: "auth",
  OVERLAY: "overlay",
};

export const REPORT_MESSAGES = [
  "Loading report…",
  "Preparing charts…",
  "Calculating results…",
  "Fetching Firebase data…",
  "Analyzing sales history…",
  "Generating analytics…",
];

export const DEFAULT_MESSAGES = [
  "Loading data…",
  "Fetching Firebase documents…",
  "Preparing dashboard…",
  "Calculating statistics…",
  "Loading sales history…",
  "Analyzing reports…",
  "Almost ready…",
  "Optimizing results…",
  "Finalizing…",
];
